const PhoneBet = () => (
  <svg width="36" height="56" xmlns="http://www.w3.org/2000/svg">
    <g fillRule="nonzero" fill="none">
      <path
        d="M35.067 5.6A5.34 5.34 0 0029.733.267H6.267A5.34 5.34 0 00.933 5.6v43.947a5.34 5.34 0 005.334 5.333h23.466a5.34 5.34 0 005.334-5.333V5.6zm-2.134 43.947c0 1.764-1.435 3.2-3.2 3.2H6.267a3.204 3.204 0 01-3.2-3.2V5.6c0-1.764 1.435-3.2 3.2-3.2h7.466A4.272 4.272 0 0018 6.667 4.272 4.272 0 0022.267 2.4h7.466c1.765 0 3.2 1.436 3.2 3.2v43.947z"
        stroke="#FFF"
        strokeWidth=".4"
        fill="#2A3135"
      />
      <path
        d="M9.828 44a.8.8 0 00.8-.8v-1.6h1.6a.8.8 0 000-1.6h-1.6v-1.6a.8.8 0 00-1.6 0V40h-1.6a.8.8 0 000 1.6h1.6v1.6a.8.8 0 00.8.8zM25.828 14.133a.8.8 0 00.8-.8v-1.6h1.6a.8.8 0 000-1.6h-1.6v-1.6a.8.8 0 00-1.6 0v1.6h-1.6a.8.8 0 000 1.6h1.6v1.6a.8.8 0 00.8.8z"
        fill="#2A3135"
      />
      <g fill="#13AD75" stroke="#13AD75">
        <path
          d="M18.14 29.698a.659.659 0 00-.238-.008 1.574 1.574 0 01-1.392-1.56.692.692 0 00-1.384 0 2.961 2.961 0 002.177 2.85v.693a.692.692 0 001.384 0v-.65a2.956 2.956 0 00-.605-5.85 1.572 1.572 0 111.571-1.571.692.692 0 001.385 0 2.961 2.961 0 00-2.35-2.894v-.63a.692.692 0 00-1.385 0v.672a2.956 2.956 0 00.779 5.807 1.57 1.57 0 01.057 3.14h0z"
          strokeWidth=".6"
        />
        <path
          d="M8.044 25.919c0 5.543 4.494 10.037 10.038 10.037 5.543 0 10.037-4.494 10.037-10.037 0-5.544-4.494-10.038-10.037-10.038-5.541.006-10.032 4.497-10.038 10.038zm10.038-8.654a8.653 8.653 0 018.653 8.654 8.653 8.653 0 01-8.653 8.653 8.653 8.653 0 01-8.654-8.653 8.663 8.663 0 018.654-8.654z"
          strokeWidth=".5"
        />
      </g>
      <path
        d="M21.2 46.347h-6.4a1.067 1.067 0 000 2.133h6.4a1.067 1.067 0 000-2.133z"
        fill="#2A3135"
      />
    </g>
  </svg>
);

export default PhoneBet;
